import React, {useState, useEffect} from "react"
import {Paper, Typography, Box, Button, FormControlLabel, Switch, Collapse, IconButton} from "@mui/material"
import { VerticalLinearStepper} from "../utils/Stepper"
import {AdvancedBox, SetupDestination} from "../utils/utils"
import CloseIcon from '@mui/icons-material/Close';
import { RequestStep0, RequestStep1, RequesTypeConvert, AssignedTypeConvert } from "../../data/RequestsData"
import { Confirm, Reject, AdvancedButton } from "./Request/RequestAction"

import { getUserName, useAuth } from "../../services/auth";
import { continueRequest, extractQr, finishRequest, getRequestDetail } from "../../services/request-api";


function RequestType(props)  {
    return RequesTypeConvert[props.request_type]
}

function AssignedType(props)  {
    return AssignedTypeConvert[props.request_type]
}

const RequestTitle = ({request_id, author, request_type}) => {
    const bridge = request_type === 0 ? "to":"from"
    return (
        <>
            <Typography sx={{fontStyle: 'bold', fontSize: '40px', display: "flex", justifyContent: "center"}}
                variant="h2"
            >
                Request ID: {request_id}
            </Typography>
            <Box  sx = {{display: "flex", justifyContent: "space-evenly", marginTop: "20px"}}>
                <Typography sx = {{fontStyle: 'italic', fontSize: '15px', color: '#909090'}}>
                    You <RequestType request_type = {request_type} /> {bridge} <b>{author}</b>
                </Typography>
            </Box>
        </>
    )
}

const DoImportTaskAction = ({stepper, request_id, user_id, handleContinue, handleFinished, fectchNotiDetail}) => {
    <Box sx = {{display: "flex", justifyContent: "flex-end", mt: 5}}>
    {stepper < 1  ? (
            <Box sx = {{display: "flex", justifyContent: "flex-end", gap: 2, my: 2}}>
                <Reject is_disbale={false} request_id={request_id} user={user_id}/>
                <Confirm is_disbale={false} request_id={request_id} onConfirm = {() =>fectchNotiDetail()}/>
            </Box>
    ) : stepper == 1 ? (
        <AdvancedButton is_disbale={false} button_label={"Continue"} handleSubmit={handleContinue}/>
    ) : stepper == 2 ? (
        <AdvancedButton is_disbale={true} button_label={"Author Confirm"} handleSubmit={handleFinished}/>
    ):null
    }
</Box>
}

export const RequestDetailType0 = ({request_id}) => {
    const [user, loading, error] = useAuth()
    const [noti, setnoti] = useState(null)
    const [stepper, setstepper] = useState(null)
    const [base64, setbase64] = useState([])
    const [Grid, setGrid] = useState(false)
    const [destination, setdestination] = useState(null)
    const [qr, setqr] = useState({})

    //advance
    const [checked, setChecked] = useState(false);
    const [note, setnote] = useState(null)

    function fectchNotiDetail() {
        getRequestDetail(request_id)
        .then(res => {
            setnoti(res);
        }
            )
        .catch(err => {console.log(err)});
    }

    useEffect(()=> {
        fectchNotiDetail()
    }, [])

    useEffect(() => {
        if (noti) {
            setstepper(noti.stepper[noti.stepper.length - 1])
        }
    }, [noti])

    const handleimage = (base64images) => {
        setbase64(base64images)
    }

    useEffect(() => {
        if (base64.length === 0) {
            setGrid(false)
        }
    }, [base64])

    const handleCloseGrid = () => {
        setGrid(false)
    }

    const handlenote = (e) => {
        setnote(e.target.value)
    }

    const handleChange = () => {
        setChecked((prev) => !prev);
        setnote(null);
        setbase64([]);
        setdestination(null)
        setGrid(false)
        };

    useEffect(()=> {
        if (base64.length > 0 && Grid === true) {
            extractQr(base64).then(res => {
                if (res === null) {
                    setqr({});
                  } else {
                    setqr(res);
                  }
            })
            .catch(err => {console.log(err)})      
        }
    }, [base64, Grid])


    const handleContinue = () => {
        // setstepper(prev => prev + 1);
        let qr_lst = null;
        if (qr.valid) {
            qr_lst = qr.valid.map((item) => item.qr_string);
        }

        let metadata = null;
        if (checked) {
            let note_ = null
            if (note) {
                note_ = {
                    'user': getUserName(user),
                    'caption': note
                }
            }

            metadata = {
                "images": base64,
                "note": note_,
                "qr_lst": qr_lst,
                "destination": destination
            };
        }
        // console.log('input: ', {
        //     "request_id": request_id,
        //     "advanced": metadata
        // })

        continueRequest({
            requestId: request_id,
            isContinueType0: true,
            advanced: metadata
        }).then(res => {
            if (res === true) {
                fectchNotiDetail()
            }
        }).catch(err => {console.log(err)})
    }

    const handleFinished= () => {
        let qr_lst = null;
        if (qr.valid) {
            qr_lst = qr.valid.map((item) => item.qr_string);
        }

        let metadata = null;
        if (checked) {
            let note_ = null
            if (note) {
                note_ = {
                    'user': getUserName(user),
                    'caption': note
                }
            }

            metadata = {
                "images": base64,
                "note": note_,
                "qr_lst": qr_lst,
                "destination": destination
            };
        }
        console.log('input: ', {
            "request_id": request_id,
            "advanced": metadata
        })

        finishRequest({
            requestId: request_id,
            isFinishedType0: true,
            advanced: metadata
        }).then(res => {
            console.log('fnished: ', res)
        }).catch(err => {console.log(err)})
    }

    return (
        <Box sx = {{width: "100%", display: "flex", gap: "10px"}}>
            <Paper sx = {{width: "800px", ml: "50px", width: "60%"}}>
                {noti && (
                    <>
                        <RequestTitle request_id={noti.request_id} author = {noti.author} request_type={noti.request_type}/>
                        <VerticalLinearStepper activeStep={stepper} step_lst = {RequestStep0} time_lst={noti.created_at} metadata={noti.metadata}/>
                        {stepper >= 1 && stepper < 2 && (
                            <Box sx = {{ml: 10, mt: 5}}>
                                <FormControlLabel
                                    control={<Switch checked={checked} onChange={handleChange} />}
                                    label="Advanced"
                                />
                                <Box sx={{ display: 'flex' }}>
                                    <Collapse
                                        in={checked}
                                        collapsedSize={0}
                                        unmountOnExit
                                        sx = {{ width: '100%' }}
                                    >
                                        <AdvancedBox handleimage={handleimage} handlenote={handlenote} setGrid={setGrid}/>
                                    </Collapse>
                                </Box>
                            </Box>
                        )}
                        <Box sx = {{display: "flex", justifyContent: "flex-end", mt: 5}}>
                                {stepper < 1 ? (
                                        <Box sx = {{display: "flex", justifyContent: "flex-end", gap: 2, my: 2}}>
                                            <Reject is_disbale={false} request_id={request_id} user={getUserName(user)}/>
                                            <Confirm is_disbale={false} request_id={request_id} onConfirm = {() =>fectchNotiDetail()}/>
                                        </Box>
                                ) : stepper == 1 ? (
                                    <AdvancedButton is_disbale={false} button_label={"Continue"} handleSubmit={handleContinue}/>
                                ) : stepper == 2 ? (
                                    <AdvancedButton is_disbale={true} button_label={"Author Confirm"} handleSubmit={handleFinished}/>
                                ):null
                                }
                        </Box>
                    </>
                )}
            </Paper>
            {Object.keys(qr).length > 0 && Grid &&
                <Paper sx = {{flex: 1}}>
                    <Box sx = {{
                        position: "relative",
                        // transform: 'translate(-50%, -50%)',
                        // width: 500,
                        bgcolor: '#fff',
                        boxShadow: 24,
                        p: 4,
                        }}>
                        <IconButton onClick = {handleCloseGrid} sx = {{position: "absolute", right: "2px", top: 1}}><CloseIcon /></IconButton>
                        <SetupDestination is_stepper_2={stepper===1} onInputchange={setdestination} qr_dct={qr}/>
                    </Box>
                </Paper>
            }
        </Box>
    )

}

export const RequestDetailType1 = ({request_id}) => {
    const [user, loading, error] = useAuth()
    const [noti, setnoti] = useState(null)
    const [stepper, setstepper] = useState(null)
    const [base64, setbase64] = useState([])
    const [Grid, setGrid] = useState(false)
    const [qr, setqr] = useState({})
    const [destination, setdestination] = useState(null)


    //advance
    const [checked, setChecked] = useState(false);
    const [note, setnote] = useState(null)
    
    function fectchNotiDetail() {
        getRequestDetail(request_id)
        .then(res => {
            setnoti(res);
        }
            )
        .catch(err => {console.log(err)});
    }

    useEffect(()=> {
        fectchNotiDetail()
    }, [])


    useEffect(() => {
        if (noti) {
            setstepper(noti.stepper[noti.stepper.length - 1])
        }
    }, [noti])

    const handleContinue = () => {
        // setstepper(prev => prev + 1);
        let qr_lst = null;
        if (qr.valid) {
            qr_lst = qr.valid.map((item) => item.qr_string);
        }

        let metadata = null;
        if (checked) {
            let note_ = null
            if (note) {
                note_ = {
                    'user': getUserName(user),
                    'caption': note
                }
            }

            metadata = {
                "images": base64,
                "note": note_,
                "qr_lst": qr_lst,
                "destination": destination
            };
        }
        // console.log('input: ', {
        //     "request_id": request_id,
        //     "advanced": metadata
        // })

        continueRequest({
            requestId: request_id,
            isContinueType0: true,
            advanced: metadata
        }).then(res => {
            if (res === true)
            fectchNotiDetail()
        }).catch(err => {console.log(err)})
    }

    const handleFinished= () => {
        let qr_lst = null;
        if (qr.valid) {
            qr_lst = qr.valid.map((item) => item.qr_string);
        }

        let metadata = null;
        if (checked) {
            let note_ = null
            if (note) {
                note_ = {
                    'user': getUserName(user),
                    'caption': note
                }
            }

            metadata = {
                "images": base64,
                "note": note_,
                "qr_lst": qr_lst,
                "destination": destination
            };
        }
        console.log('input: ', {
            "request_id": request_id,
            "advanced": metadata
        })

        finishRequest({
            requestId: request_id,
            isFinishedType0: true,
            advanced: metadata
        }).then(res => {
            if (res === true) {
                fectchNotiDetail()
            }
        }).catch(err => {console.log(err)})
    }
    const handleimage = (base64images) => {
        setbase64(base64images)
    }

    useEffect(() => {
        if (base64.length === 0) {
            setGrid(false)
        }
    }, [base64])

    const handleCloseGrid = () => {
        setGrid(false)
        setqr({})
        setdestination(null)
    }

    const handlenote = (e) => {
        setnote(e.target.value)
    }


    const handleChange = () => {
        setChecked((prev) => !prev);
        setnote(null);
        setbase64([]);
        setdestination(null)
        setGrid(false)
        };

    useEffect(()=> {
        if (base64.length > 0 && Grid === true) {
            extractQr(base64).then(res => {
                if (res === null) {
                    setqr({});
                  } else {
                    setqr(res);
                  }
            })
            .catch(err => {console.log(err)})      
        }
    }, [base64, Grid])

    console.log('stepper: ', stepper)

    return (
        <Box sx = {{width: "100%", display: "flex", gap: "10px", justifyContent: "center"}}>
            <Paper sx = {{width: "800px", ml: "50px", width: "60%"}}>
                {noti && user && (
                    <>
                        <RequestTitle request_id={noti.request_id} author = {noti.author} request_type={noti.request_type}/>
                        <VerticalLinearStepper activeStep={stepper} step_lst = {RequestStep1} time_lst={noti.created_at} metadata={noti.metadata}/>
                        {stepper === 1 || stepper === 2 && (
                            <Box sx = {{ml: 10, my: 5}}>
                                <FormControlLabel
                                    control={<Switch checked={checked} onChange={handleChange} />}
                                    label="Advanced"
                                />
                                <Box sx={{ display: 'flex' }}>
                                    <Collapse
                                        in={checked}
                                        collapsedSize={0}
                                        unmountOnExit
                                        sx = {{ width: '100%' }}
                                    >
                                        <AdvancedBox handleimage={handleimage} handlenote={handlenote} setGrid={setGrid}/>
                                    </Collapse>
                                </Box>
                            </Box>
                        )}
                        <Box sx = {{display: "flex", justifyContent: "flex-end", mt: 5}}>
                                {stepper < 1 ? (
                                        <Box sx = {{display: "flex", justifyContent: "flex-end", gap: 2, my: 2}}>
                                            <Reject is_disbale={false} request_id={request_id} user={getUserName(user)}/>
                                            <Confirm is_disbale={false} request_id={request_id} onConfirm = {() => {fectchNotiDetail()}}/>
                                        </Box>
                                ) : stepper == 1 ? (
                                    <AdvancedButton is_disbale={true} button_label={"Author Preparing"} handleSubmit={handleContinue}/>
                                ) : stepper == 2 ? (
                                    <AdvancedButton is_disbale={false} button_label={"Finished Request"} handleSubmit={handleFinished}/>
                                ):null
                                }
                        </Box>
                    </>
                )}
            </Paper>
            {Object.keys(qr).length > 0 && Grid &&
                <Paper sx = {{flex: 1}}>
                    <Box sx = {{
                        position: "relative",
                        // transform: 'translate(-50%, -50%)',
                        // width: 500,
                        bgcolor: '#fff',
                        boxShadow: 24,
                        p: 4,
                        }}>
                        <IconButton onClick = {handleCloseGrid} sx = {{position: "absolute", right: "2px", top: 1}}><CloseIcon /></IconButton>
                        <SetupDestination is_stepper_2={stepper===1} onInputchange={setdestination} qr_dct={qr}/>
                    </Box>
                </Paper>
            }
        </Box>
    )
}

export const AssignedDetailType0 = ({request_id}) => {
    const [user, loading, error] = useAuth()
    const [noti, setnoti] = useState(null)
    const [stepper, setstepper] = useState(null)
    const [base64, setbase64] = useState([])
    const [Grid, setGrid] = useState(false)
    const [qr, setqr] = useState({})
    const [destination, setdestination] = useState(null)


    //advance
    const [checked, setChecked] = useState(false);
    const [note, setnote] = useState(null)


    function fectchNotiDetail() {
        getRequestDetail(request_id)
        .then(res => {
            setnoti(res);
        }
            )
        .catch(err => {console.log(err)});
    }

    useEffect(()=> {
        fectchNotiDetail()
    }, [])

    useEffect(() => {
        if (noti) {
            setstepper(noti.stepper[noti.stepper.length - 1])
            console.log(stepper)
        }
    }, [noti])

    const handleFinished= () => {
        let qr_lst = null;
        if (qr.valid) {
            qr_lst = qr.valid.map((item) => item.qr_string);
        }

        let metadata = null;
        if (checked) {
            let note_ = null
            if (note) {
                note_ = {
                    'user': getUserName(user),
                    'caption': note
                }
            }

            metadata = {
                "images": base64,
                "note": note_,
                "qr_lst": qr_lst,
                "destination": destination
            };
        }
        // console.log('input: ', {
        //     "request_id": request_id,
        //     "advanced": metadata
        // })

        finishRequest({
            requestId: request_id,
            isFinishedType0: false,
            advanced: metadata
        }).then(res => {
            if (res === true) {
                fectchNotiDetail()
            }
        }).catch(err => {console.log(err)})
    }
    const handleimage = (base64images) => {
        setbase64(base64images)
    }

    useEffect(() => {
        if (base64.length === 0) {
            setGrid(false)
        }
    }, [base64])

    const handleCloseGrid = () => {
        setGrid(false)
        setqr({})
        setdestination(null)
    }

    const handlenote = (e) => {
        setnote(e.target.value)
    }


    const handleChange = () => {
        setChecked((prev) => !prev);
        setnote(null);
        setbase64([]);
        setdestination(null)
        setGrid(false)
        };

    useEffect(()=> {
        if (base64.length > 0 && Grid === true) {
            extractQr(base64).then(res => {
                if (res === null) {
                    setqr({});
                  } else {
                    setqr(res);
                  }
            })
            .catch(err => {console.log(err)})      
        }
    }, [base64, Grid])

    return (
        <>
        <Box sx = {{width: "100%", display: "flex", justifyContent: "center"}}>
            <Paper sx = {{ width: "800px"}}>
                {noti && (
                    <>
                        <Typography sx={{fontStyle: 'bold', fontSize: '40px', display: "flex", justifyContent: "center"}}
                            variant="h2"
                        >
                            Request ID: {noti.request_id} - <RequestType request_type = {noti.request_type} />
                        </Typography>
                        <Box  sx = {{display: "flex", justifyContent: "space-evenly", marginTop: "20px"}}>
                            <Typography sx = {{fontStyle: 'italic', fontSize: '15px', color: '#909090'}}>
                                <b>{noti.asssignee}</b> <AssignedType request_type = {noti.request_type} />
                            </Typography>
                        </Box>
                        <VerticalLinearStepper activeStep={stepper} step_lst = {RequestStep0} time_lst={noti.created_at} metadata={noti.metadata}/>
                        {stepper === 2 && (
                            <Box sx = {{ml: 10, my: 5}}>
                                <FormControlLabel
                                    control={<Switch checked={checked} onChange={handleChange} />}
                                    label="Advanced"
                                />
                                <Box sx={{ display: 'flex' }}>
                                    <Collapse
                                        in={checked}
                                        collapsedSize={0}
                                        unmountOnExit
                                        sx = {{ width: '100%' }}
                                    >
                                        <AdvancedBox handleimage={handleimage} handlenote={handlenote} setGrid={setGrid}/>
                                    </Collapse>
                                </Box>
                            </Box>
                        )}
                        <Box sx = {{display: "flex", justifyContent: "flex-end"}}>
                                {stepper < 2 ?  (
                                    <AdvancedButton is_disbale={true} button_label={"Finished"} handleSubmit={handleFinished}/>
                                ) : stepper == 2 ? (
                                    <AdvancedButton is_disbale={false} button_label={"Finished"} handleSubmit={handleFinished}/>
                                ): null
                            }
                        </Box>
                    </>
                )}
            </Paper>
            {Object.keys(qr).length > 0 && Grid &&
                <Paper sx = {{flex: 1}}>
                    <Box sx = {{
                        position: "relative",
                        // transform: 'translate(-50%, -50%)',
                        // width: 500,
                        bgcolor: '#fff',
                        boxShadow: 24,
                        p: 4,
                        }}>
                        <IconButton onClick = {handleCloseGrid} sx = {{position: "absolute", right: "2px", top: 1}}><CloseIcon /></IconButton>
                        <SetupDestination is_stepper_2={stepper===1} onInputchange={setdestination} qr_dct={qr}/>
                    </Box>
                </Paper>
            }
        </Box>
        </>
    )

}

export const AssignedDetailType1 = ({request_id}) => {
    const [user, loading, error] = useAuth()
    const [noti, setnoti] = useState(null)
    const [stepper, setstepper] = useState(null)
    const [base64, setbase64] = useState([])
    const [Grid, setGrid] = useState(false)
    const [qr, setqr] = useState({})
    const [destination, setdestination] = useState(null)


    //advance
    const [checked, setChecked] = useState(false);
    const [note, setnote] = useState(null)

    function fectchNotiDetail() {
        getRequestDetail(request_id)
        .then(res => {
            setnoti(res);
        }
            )
        .catch(err => {console.log(err)});
    }
    useEffect(()=> {
        fectchNotiDetail()
    }, [])

    useEffect(() => {
        if (noti) {
            setstepper(noti.stepper[noti.stepper.length - 1])
        }
    }, [noti])

    const handleContinue = () => {
        // setstepper(prev => prev + 1);
        let qr_lst = null;
        if (qr.valid) {
            qr_lst = qr.valid.map((item) => item.qr_string);
        }

        let metadata = null;
        if (checked) {
            let note_ = null
            if (note) {
                note_ = {
                    'user': getUserName(user),
                    'caption': note
                }
            }

            metadata = {
                "images": base64,
                "note": note_,
                "qr_lst": qr_lst,
                "destination": destination
            };
        }
        // console.log('input: ', {
        //     "request_id": request_id,
        //     "advanced": metadata
        // })

        continueRequest({
            requestId: request_id,
            isContinueType0: false,
            advanced: metadata
        }).then(res => {
            if (res === true) {
                fectchNotiDetail()
            }
        }).catch(err => {console.log(err)})
    }

    const handleimage = (base64images) => {
        setbase64(base64images)
    }

    useEffect(() => {
        if (base64.length === 0) {
            setGrid(false)
        }
    }, [base64])

    const handleCloseGrid = () => {
        setGrid(false)
        setqr({})
        setdestination(null)
    }

    const handlenote = (e) => {
        setnote(e.target.value)
    }

    const handleChange = () => {
        setChecked((prev) => !prev);
        setnote(null);
        setbase64([]);
        setdestination(null)
        setGrid(false)
        };

    useEffect(()=> {
        if (base64.length > 0 && Grid === true) {
            extractQr(base64).then(res => {
                if (res === null) {
                    setqr({});
                  } else {
                    setqr(res);
                  }
            })
            .catch(err => {console.log(err)})      
        }
    }, [base64, Grid])

    return (
        <>
        <Box sx = {{width: "100%", display: "flex", justifyContent: "center"}}>
            <Paper sx = {{ width: "800px"}}>
                {noti && (
                    <>
                        <Typography sx={{fontStyle: 'bold', fontSize: '40px', display: "flex", justifyContent: "center"}}
                            variant="h2"
                        >
                            Request ID: {noti.request_id} - <RequestType request_type = {noti.request_type} />
                        </Typography>
                        <Box  sx = {{display: "flex", justifyContent: "space-evenly", marginTop: "20px"}}>
                            <Typography sx = {{fontStyle: 'italic', fontSize: '15px', color: '#909090'}}>
                                You requests <b>{noti.asssignee}</b> to <AssignedType request_type = {noti.request_type} />
                            </Typography>
                        </Box>
                        <VerticalLinearStepper activeStep={stepper} step_lst = {RequestStep0} time_lst={noti.created_at} metadata={noti.metadata}/>
                        {stepper === 1 && (
                            <Box sx = {{ml: 10, my: 5}}>
                                <FormControlLabel
                                    control={<Switch checked={checked} onChange={handleChange} />}
                                    label="Advanced"
                                />
                                <Box sx={{ display: 'flex' }}>
                                    <Collapse
                                        in={checked}
                                        collapsedSize={0}
                                        unmountOnExit
                                        sx = {{ width: '100%' }}
                                    >
                                        <AdvancedBox handleimage={handleimage} handlenote={handlenote} setGrid={setGrid}/>
                                    </Collapse>
                                </Box>
                            </Box>
                        )}
                        <Box sx = {{display: "flex", justifyContent: "flex-end"}}>
                                {stepper < 1 ? (
                                    <AdvancedButton is_disbale={true} button_label={"Process Request"} handleSubmit={handleContinue}/>
                                ):
                                stepper === 1 ?  (
                                    <AdvancedButton is_disbale={false} button_label={"Process Request"} handleSubmit={handleContinue}/>
                                ) : stepper === 2 ? (
                                    <AdvancedButton is_disbale={true} button_label={"Finished Request"} handleSubmit={handleContinue}/>
                                ): null
                            }
                        </Box>
                    </>
                )}
            </Paper>
            {Object.keys(qr).length > 0 && Grid &&
                <Paper sx = {{flex: 1}}>
                    <Box sx = {{
                        position: "relative",
                        // transform: 'translate(-50%, -50%)',
                        // width: 500,
                        bgcolor: '#fff',
                        boxShadow: 24,
                        p: 4,
                        }}>
                        <IconButton onClick = {handleCloseGrid} sx = {{position: "absolute", right: "2px", top: 1}}><CloseIcon /></IconButton>
                        <SetupDestination is_stepper_2={stepper===1} onInputchange={setdestination} qr_dct={qr}/>
                    </Box>
                </Paper>
            }
        </Box>
        </>
    )
}
